import React from 'react'
import HotkeysGroup from './HotkeysGroup'

export default function Other() {
  return (
    <HotkeysGroup
      title="Other"
      hotkeys={{
        '?': 'View shortcut overview screen',
        'shift+n': 'Open new conversation',
      }}
    />
  )
}
